import axios from 'axios';
import state_translates from "@/data/translates/states/index.json"

export default {
  state: {
    activeSports: [],
    activeSportsNew: [],
    // filters: [],
    filters: JSON.parse(localStorage.getItem('filters')) ?? [],
    // filters: [ 
    //   { filter: 'next', group: 'status' }, 
    //   { filter: 'now', group: 'status' }, 
    //   { filter: 'stories', group: 'status' }, 
    // ],
    bounds: null,
    sports_i: [],
    sports_new_i: [],
    date: [],
    search_events: '',
    search_places: '',
    countries: [],
    states: [],
  },
  mutations: {
    setFilters(state, filters) {
      state.filters = filters;
      localStorage.setItem('filters', JSON.stringify(filters))
    },
    setSearchEvents(state, val) {
      state.search_events = val;
    },
    setSearchPlaces(state, val) {
      state.search_places = val;
    },
    setSports(state, sports) {
      state.sports_i = sports;
    },
    setSportsNew(state, sports) {
      state.sports_new_i = sports;
    },
    setActiveSports(state, active) {
      state.activeSports = active;
    },
    setActiveSportsNew(state, active) {
      state.activeSportsNew = active;
    },
    setCounties(state, countries) {
      state.countries = countries;
    },
    setCities(state, states) {
      state.states = states;
    },
    setDate(state, date) {
      state.date = date;
    },
    setBounds(state, bounds) {
      state.bounds = bounds;
    },
    setLocationState(state, city) {
      let findedCountry = state.filters.find(item => item.group === 'city');
      findedCountry ? state.filters.splice(state.filters.indexOf(findedCountry), 1) : '';
      state.filters.push({filter: city, group: 'city'})
    }
  },
  actions: {
    setLocationState({commit}, state) {
      commit('setLocationState', state)
    },
    async fetchCities({ commit }, filter) {
      let result = null;
      commit;
      await axios
        .post('https://countriesnow.space/api/v0.1/countries/states', {
          country: filter.name,
        }, { withCredentials: false })
        .then(async response => {
          result = response.data.data.states;
          result = await result.map(state => {
            state_translates.ru[state.name] ? state.ru = state_translates.ru[state.name] : state;
            return state
          });
          commit('setCities', result)
        })
      return result;
    },
    async fetchCountries({commit}) {
      let result = null;
      await axios
        .get('https://countriesnow.space/api/v0.1/countries/iso', { withCredentials: false })
        .then((response) => {
          result = response.data.data;
          commit('setCounties', result)
        })
      return result;
    },
    async sendNewCategory({ dispatch }, newCategory) {
      let result = null;
      await axios
        .post(`/api/sports/newoffer`, newCategory)
        .then((response) => {
          result = response.data;
        })
        .catch((error) => {
          dispatch('addError', { message: error.response.data });
        });
      return result;
    },
    setFilters({ commit }, filters) {
      commit('setFilters', filters);
    },
    async fetchSports({ dispatch, commit }) {
      let result = null;
      await axios
        .get(`/api/sports/getall`)
        .then((response) => {
          result = response.data;
          commit('setSports', result);
          commit('setSportsNew', result);
        })
        .catch((error) => {
          dispatch('addError', { message: error.response.data });
        });
      return result;
    },
    setSports({ commit }, sports) {
      commit('setSports', sports);
    },
    setSportsNew({ commit }, sports) {
      commit('setSportsNew', sports);
    },
    setDate({ commit }, date) {
      commit('setDate', date);
    },
    setBounds({ commit }, bounds) {
      commit('setBounds', bounds);
    },
    async changeSports({ state, commit }, element) {
      let id = Number(element.id);
      let sports = state.activeSports;
      let finded = sports.find((sport) => sport.id === id);
      finded ? (sports = sports.filter((sport) => sport.id !== finded.id)) : sports.push(element);
      commit('setActiveSports', sports);
    },
    async changeSportsNew({ state, commit }, element) {
      let id = Number(element.id);
      let sports_new = state.activeSportsNew;
      let finded = sports_new.find((sport) => sport.id === id);
      finded
        ? (sports_new = sports_new.filter((sport) => sport.id !== finded.id))
        : sports_new.push(element);
      commit('setActiveSportsNew', sports_new);
    },
    async clearSportsNew({ commit }) {
      commit('setActiveSportsNew', [])
    },
  },
  getters: {
    getActiveSports: (s) => s.activeSports,
    getActiveSportsNew: (s) => s.activeSportsNew,
    getSports: (s) => s.sports_i,
    getSportsNew: (s) => s.sports_new_i,
    getFilters: (s) => s.filters,
    getBounds: (s) => s.bounds,
    getDate: (s) => s.date,
    getCountries: (s) => s.countries,
    getStates: (s) => s.states,
    getSearchEvents: (s) => s.search_events,
    getSearchPlaces: (s) => s.search_places,
  },
};
